module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG5d0afcd34128e1c76a754dcdce25ddb9.5d0afcd3.png";